<template>
  <v-card class="rounded-xl day-supp-counter-rental-file py-2" :border="false" :elevation="0">
    <v-col cols="12" class="d-flex justify-center">
      <p>
        {{ $t('DAY_SUPP_COUNT_DATE_RENTAL_FILE.TITLE_1') }}<br>
        {{ $t('DAY_SUPP_COUNT_DATE_RENTAL_FILE.TITLE_2')}}
    </p>
    </v-col>
    <v-col cols="12" class="d-flex justify-center big-text">
      {{ dayCountSuppDate }} {{ $t('DAY_SUPP_COUNT_DATE_RENTAL_FILE.DAYS') }}
    </v-col>
  </v-card>
</template>

<script>
import RentalFileService from '@/services/rentalModule/RentalFileService'
import { RentalFileSummary } from '@/models/rentalModule/RentalFileSummary'

export default {
  name: 'DaySuppCounterRentalFile',
  props: {
    rentalFileSummary: RentalFileSummary
  },
  data() {
    return {
      loading: true,
      dayCountSuppDate: 0
    }
  },
  created() {
    this.getDayCountSuppDate()
  },
  watch: {
    rentalFileSummary() {
      this.getDayCountSuppDate()
    }
  },
  methods: {
    async getDayCountSuppDate() {
      this.loading = true
      try {
        const response = await RentalFileService
          .getRentalFileDayCountSuppDate(this.rentalFileSummary.rental_file_technical_id)
        const dayCountSuppDate_ = response.day_supp_count_date
        if (dayCountSuppDate_ < 3) {
          this.dayCountSuppDate = 0
        } else {
          this.dayCountSuppDate = dayCountSuppDate_ -2
        }
      } catch (error) {
        displayToast(this.$t('ERROR_STATUS_CODE_MESSAGE.' + (error.response ? error.response.status : 'UNKNOWN')), 'error')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.day-supp-counter-rental-file {
  position: relative;
  min-height: 128;
}

.big-text {
  font-size: 18px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}
</style>
